import { QuerySettingsDto, RequestType } from '@thingslog/repositories';
import { QuerySettingsFactory } from '../../../../factories/QuerySettings.factory';

export const createDefaultQuerySettings = (type: RequestType): QuerySettingsDto => {
  switch (type) {
    case 'api-alarms-count':
      return QuerySettingsFactory.create({
        type,
        timespan: null,
      });
    case 'api-battery-histogram':
      return QuerySettingsFactory.create({
        type,
      });
    case 'api-device-sensor':
      return QuerySettingsFactory.create({
        type,
        deviceNumber: '',
        sensorIndex: '0',
        timespan: null,
      });
    case 'api-devices-battery':
      return QuerySettingsFactory.create({
        type,
        specificDevices: [],
        fromLevel: '0',
        toLevel: '100',
      });
    case 'api-devices-signal':
      return QuerySettingsFactory.create({
        type,
        specificDevices: [],
        fromLevel: '0',
        toLevel: '100',
        metrics: ['level'],
      });
    case 'api-devices-transmissions':
      return QuerySettingsFactory.create({
        type,
        metrics: ['days'],
      });
    case 'api-signal-histogram':
      return QuerySettingsFactory.create({
        type,
      });
    case 'api-readings-device-groups':
      return QuerySettingsFactory.create({
        type,
        deviceGroupIds: [],
        timespan: null,
        preferFlow: false,
      });
    case 'api-readings-device-sensor-list':
      return QuerySettingsFactory.create({
        type,
        deviceSensors: [],
        timespan: null,
        preferFlow: false,
      });
    case 'api-readings-device-sensor-type-list':
      return QuerySettingsFactory.create({
        type,
        deviceSensorTypes: [],
        timespan: null,
        preferFlow: false,
      });
    case 'api-readings-mixed':
      return QuerySettingsFactory.create({
        type,
        deviceGroupIds: [],
        deviceSensors: [],
        deviceSensorTypes: [],
        timespan: null,
        preferFlow: false,
      });
    default:
      throw new Error('Unknown query settings type');
  }
};
